export class EpgNewsUpload {
    imageName: string;
    imageFile: File;
}